import { render, staticRenderFns } from "./InspectionParameters.vue?vue&type=template&id=36fc7daf&scoped=true&"
import script from "./InspectionParameters.vue?vue&type=script&lang=ts&"
export * from "./InspectionParameters.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionParameters.vue?vue&type=style&index=0&id=36fc7daf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc7daf",
  null
  
)

export default component.exports